"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (time) {
  return new Promise(function (resolve) {
    setTimeout(resolve, time);
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-apollo-decorators/lib/sleep.js
// module id = 1283
// module chunks = 0